"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("./Icon"));
var Input = function (_a) {
    var value = _a.value, onChange = _a.onChange, type = _a.type, className = _a.className, disabled = _a.disabled, leadingIcon = _a.leadingIcon, placeholder = _a.placeholder, trailingIcon = _a.trailingIcon;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-input", disabled && "disabled", className) },
        leadingIcon ? (react_1.default.createElement(Icon_1.default, { icon: leadingIcon, className: "ui-input-item-icon-left", size: "small" })) : null,
        react_1.default.createElement("input", { className: (0, classnames_1.default)(leadingIcon && 'ui-input-leading-icon', trailingIcon && 'ui-input-trailing-icon'), type: type, value: value, placeholder: placeholder, disabled: disabled, onChange: function (e) { return onChange(e.target.value); } }),
        trailingIcon ? (react_1.default.createElement(Icon_1.default, { icon: trailingIcon, className: "ui-input-item-icon-right", size: "small" })) : null));
};
exports.default = Input;
